import PureCloud from "./purecloud.service";

const purecloudModule = angular
  .module("app.services.pureCloud", [])
  .service("PureCloud", PureCloud);

export default purecloudModule;



// WEBPACK FOOTER //
// ./src/services/purecloud/purecloud.module.js